@if ((dimensions | async); as dimensions) {
  <svg:rect
    class="listening-zone"
    [attr.x]="dimensions.marginLeft"
    [attr.y]="dimensions.marginTop"
    [attr.width]="dimensions.boundedWidth"
    [attr.height]="dimensions.boundedHeight" />
}
